const chatActions = require('./chat-actions')
const chatUi = require('./chat-ui')
const chatNetwork = require('./chat-network')
const settings = require('../../js-handler/settings')

export function load(data) {

    let rows;
    try {
        rows = typeof data.chats === 'string' ? JSON.parse(data.chats) : data.chats;
    } catch (e) {
        rows = data.chats;
    }

    chatUi.renderHistory(rows)
    chatActions.scrollToBottom()
    chatActions.hideLoading();
}

export function getChats(detail) {
    // Muestra la animación de carga
    chatActions.showLoading();
    chatNetwork.send(detail, (response) => {
        load(response)
    })
}

export function submit(detail) {
    const tempId = 'temp-' + Date.now()
    const optimisticMsg = {
        id: tempId,
        sms: detail.question,
        time: new Date().toISOString(),
        avatar: 'css/img/pic/person.svg', // o settings / usuario si lo tienes
        status: 'sent', // opcional; si no pones nada, no aplica msg-sent (ver generateMessageHTML)
    }

    chatUi.appendMessage(optimisticMsg, true)
    chatActions.scrollToBottom()

    // Muestra la animación de carga
    chatActions.showLoading();
    chatNetwork.send(detail, (response) => {

        load(response)
    })
}

export function typing(detail) {
    if (detail.ev.key === 'Enter') {
        const chatInputElem = detail.ev.target
        const btn = chatInputElem.nextElementSibling
        btn.click()
    }
}

export function selectUser(detail) {
    chatActions.setActiveUser(detail)

    chatNetwork.getHistory(detail.userId, (history) => {
        chatUi.renderHistory(history)
        chatActions.scrollToBottom()
    })
}

export function receiveMessage(detail) {
    if (chatActions.getCurrentUserId() === detail.fromUserId) {
        chatUi.appendMessage(detail, false)
        chatActions.scrollToBottom()
    } else {
        //
    }
}